import { useEffect } from "react";
import { createRoot } from "react-dom/client";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import * as Sentry from "@sentry/react";
import "src/assets/css/admin.css";
import { initializeGA } from "src/utils/analytics";
import { AppInitializer } from "src/initializers";
import { AppProviders } from "src/context";
import LoginPage from "./pages/LoginPage";
import LoginConfirmationPage from "./pages/LoginConfirmationPage";
import ProtectedLayout from "./layouts/ProtectedLayout";
import ErrorPage from "./pages/ErrorPage";
import PreApprovalApp from "./pages/PreApproval/PreApprovalApp";
import ConditionsInbox from "./pages/ConditionsInbox";
import RCMApp from "./vibe-code/rcm-v2/RCMApp";

Sentry.init({
  dsn: __SENTRY_DSN__,
  environment: __ENV__,
  release: __SENTRY_RELEASE__,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.browserProfilingIntegration(),
    Sentry.replayIntegration(),
  ],
  replaysSessionSampleRate: 0.0,
  replaysOnErrorSampleRate: 1.0,
});

const App = () => {
  useEffect(() => {
    initializeGA();
  }, []);

  return (
    <AppProviders>
      <Router
        future={{
          v7_startTransition: false,
          v7_relativeSplatPath: false,
        }}
      >
        <AppInitializer>
          <Routes>
            <Route path="/" element={<Navigate to="/login" replace />} />
            <Route path={"login"}>
              <Route index element={<LoginPage />} />
              <Route
                path={"confirmation"}
                element={<LoginConfirmationPage />}
              />
            </Route>
            <Route element={<ProtectedLayout />}>
              <Route path="/pre-approval/*" element={<PreApprovalApp />} />
              <Route path="/conditions-inbox" element={<ConditionsInbox />} />
              <Route path="/rcm" element={<RCMApp />} />
            </Route>
            <Route path="error" element={<ErrorPage />} />
            <Route path="*" element={<Navigate to="/error" replace />} />
          </Routes>
        </AppInitializer>
      </Router>
    </AppProviders>
  );
};
const root = createRoot(document.getElementById("main")!);
root.render(<App />);
